import namespace from "@rdfjs/namespace";
export const grddl = namespace("http://www.w3.org/2003/g/data-view#");
